"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RichEditor = void 0;
const is_hotkey_1 = __importDefault(require("is-hotkey"));
const slate_1 = require("slate");
const slate_history_1 = require("slate-history");
const slate_react_1 = require("slate-react");
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const lodash_1 = require("lodash");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const Code_1 = __importDefault(require("@material-ui/icons/Code"));
const Filter1_1 = __importDefault(require("@material-ui/icons/Filter1"));
const Filter2_1 = __importDefault(require("@material-ui/icons/Filter2"));
const FormatBold_1 = __importDefault(require("@material-ui/icons/FormatBold"));
const FormatItalic_1 = __importDefault(require("@material-ui/icons/FormatItalic"));
const FormatListBulleted_1 = __importDefault(require("@material-ui/icons/FormatListBulleted"));
const FormatListNumbered_1 = __importDefault(require("@material-ui/icons/FormatListNumbered"));
const FormatQuote_1 = __importDefault(require("@material-ui/icons/FormatQuote"));
const FormatUnderlined_1 = __importDefault(require("@material-ui/icons/FormatUnderlined"));
const block_button_1 = require("./parts/block-button");
const element_1 = require("./parts/element");
const leaf_1 = require("./parts/leaf");
const mark_button_1 = require("./parts/mark-button");
const unwrap_link_button_1 = require("./parts/unwrap-link-button");
const wrap_link_button_1 = require("./parts/wrap-link-button");
const rich_editor_styles_1 = require("./rich-editor-styles");
const deserialize_1 = require("./utils/deserialize");
const serialize_1 = require("./utils/serialize");
const toggle_mark_1 = require("./utils/toggle-mark");
const HOTKEYS = {
    'mod+b': 'bold',
    'mod+i': 'italic',
    'mod+u': 'underline',
    'mod+`': 'code',
};
const INIT_VALUE = '<p></p>';
function Editor({ initialValue: initialValue, onChange, }) {
    const classes = (0, rich_editor_styles_1.useStyles)();
    initialValue = initialValue !== null && initialValue !== void 0 ? initialValue : INIT_VALUE;
    const document = new DOMParser().parseFromString(initialValue.startsWith('<') ? initialValue : `<p>${initialValue}</p>`, 'text/html');
    const value = (0, deserialize_1.deserialize)(document.body);
    (0, react_1.useEffect)(() => {
        var _a, _b, _c;
        editor.children = value;
        const hasPosition = slate_1.Node.has(editor, (_c = (_b = (_a = editor.selection) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.path) !== null && _c !== void 0 ? _c : [0, 0]);
        if (!hasPosition) {
            const point = { path: [0, 0], offset: 0 };
            editor.selection = { anchor: point, focus: point };
        }
        editor.history = { redos: [], undos: [] };
        editor.onChange();
    }, [value]);
    const editor = (0, react_1.useMemo)(() => (0, slate_history_1.withHistory)((0, slate_react_1.withReact)((0, slate_1.createEditor)())), []);
    const renderElement = (0, react_1.useCallback)((props) => react_1.default.createElement(element_1.Element, { ...props }), []);
    const renderLeaf = (0, react_1.useCallback)((props) => react_1.default.createElement(leaf_1.Leaf, { ...props }), []);
    return (react_1.default.createElement("div", { style: { width: '100%' } },
        react_1.default.createElement(slate_react_1.Slate, { editor: editor, value: value, onChange: (value) => {
                onChange((0, serialize_1.serialize)(value));
            } },
            react_1.default.createElement("div", null,
                react_1.default.createElement(mark_button_1.MarkButton, { format: "bold", icon: react_1.default.createElement(FormatBold_1.default, { fontSize: "small" }) }),
                react_1.default.createElement(mark_button_1.MarkButton, { format: "italic", icon: react_1.default.createElement(FormatItalic_1.default, { fontSize: "small" }) }),
                react_1.default.createElement(mark_button_1.MarkButton, { format: "underline", icon: react_1.default.createElement(FormatUnderlined_1.default, { fontSize: "small" }) }),
                react_1.default.createElement(mark_button_1.MarkButton, { format: "code", icon: react_1.default.createElement(Code_1.default, { fontSize: "small" }) }),
                react_1.default.createElement(wrap_link_button_1.WrapLinkButton, null),
                react_1.default.createElement(unwrap_link_button_1.UnwrapLinkButton, null),
                react_1.default.createElement(block_button_1.BlockButton, { format: "heading-one", icon: react_1.default.createElement(Filter1_1.default, { fontSize: "small" }) }),
                react_1.default.createElement(block_button_1.BlockButton, { format: "heading-two", icon: react_1.default.createElement(Filter2_1.default, { fontSize: "small" }) }),
                react_1.default.createElement(block_button_1.BlockButton, { format: "block-quote", icon: react_1.default.createElement(FormatQuote_1.default, { fontSize: "small" }) }),
                react_1.default.createElement(block_button_1.BlockButton, { format: "numbered-list", icon: react_1.default.createElement(FormatListNumbered_1.default, { fontSize: "small" }) }),
                react_1.default.createElement(block_button_1.BlockButton, { format: "bulleted-list", icon: react_1.default.createElement(FormatListBulleted_1.default, { fontSize: "small" }) })),
            react_1.default.createElement(slate_react_1.Editable, { renderElement: renderElement, renderLeaf: renderLeaf, spellCheck: true, autoFocus: false, scrollSelectionIntoView: lodash_1.noop, onKeyDown: (event) => {
                    for (const hotkey in HOTKEYS) {
                        if ((0, is_hotkey_1.default)(hotkey, event)) {
                            event.preventDefault();
                            const mark = HOTKEYS[hotkey];
                            (0, toggle_mark_1.toggleMark)(editor, mark);
                        }
                    }
                }, className: (0, clsx_1.default)(classes.editor, classes.active) }))));
}
function RichEditor({ value, onChange, disabled, }) {
    const classes = (0, rich_editor_styles_1.useStyles)();
    return (react_1.default.createElement(react_1.default.Fragment, null, !disabled ? (react_1.default.createElement(Editor, { initialValue: value, onChange: onChange })) : (react_1.default.createElement(Typography_1.default, { variant: "body1", component: "div", className: classes.editor },
        react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                __html: value,
            } })))));
}
exports.RichEditor = RichEditor;
//# sourceMappingURL=rich-editor.js.map